/**
 * Extracts the filename from a Content-Disposition header value.
 * Supports the RFC 5987 `filename*=UTF-8''...` form (preferred when present)
 * and the plain `filename=` form, optionally quoted.
 * Returns null when no filename can be determined.
 */
export const parseContentDispositionFilename = (header: string | null): string | null => {
    if (!header) {
        return null;
    }
    const extendedMatch = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header);
    if (extendedMatch) {
        try {
            return decodeURIComponent(extendedMatch[1].trim().replace(/(?:^")|(?:"$)/g, ''));
        } catch {
            return null;
        }
    }
    const plainMatch = /filename="?([^";]+)"?/i.exec(header);
    if (plainMatch) {
        const filename = plainMatch[1].trim();
        return filename.length > 0 ? filename : null;
    }
    return null;
};
